// Resources
import API from "../helpers/API"

/**
 * Componente funcional para manipulacão dos dados de combos
 */
const ComboController = {
  fetchOne(uuid_combo) {
    return API.request("/v1/combo/" + uuid_combo, [], "GET")
  },

  fetchComboProducts(uuid_combo, options) {
    const { signal } = options

    return API.request("/v1/combo/" + uuid_combo + "/products", [], "GET", {}, 30000, 3, signal)
  },

  fetchComboBeverages(uuid_combo) {
    return API.request("/v1/combo/" + uuid_combo + "/beverages", [], "GET")
  },

  fetchComboSizesProduct(comboProductId, productId, options) {
    const { signal } = options

    return API.request("/v1/combo/" + comboProductId + "/product/" + productId + "/sizes", [], "GET", {}, 30000, 3, signal)
  },

  fetchComboFlavoursProduct(comboProductId, productId, params, options) {
    let signal = null
    if (options && options.signal) {
      signal = options.signal
    }
    return API.request("/v1/combo/" + comboProductId + "/product/" + productId + "/flavours/website", params, "GET", {}, 30000, 3, signal)
  },

  fetchComboAdditionalsProduct(comboProductId, productId, complementId, options) {
    const { signal } = options

    return API.request(
      "/v1/combo/" + comboProductId + "/product/" + productId + "/complement/" + complementId + "/additionals",
      [],
      "GET",
      {},
      30000,
      3,
      signal
    )
  },

  fetchComboComplementsProduct(comboProductId, productId, options) {
    const { signal } = options

    return API.request("/v1/combo/" + comboProductId + "/product/" + productId + "/complements", [], "GET", {}, 30000, 3, signal)
  },

  fetchComboBeveragesProduct(comboProductId, options) {
    const { signal } = options

    return API.request("/v1/combo/" + comboProductId + "/product/beverages", [], "GET", {}, 30000, 3, signal)
  },

  fetchAll(filter = {}) {
    return API.request("/v1/combo", filter, "GET")
  },
}

export default ComboController
